import { render } from "./Boosters.vue?vue&type=template&id=123604ee"
import script from "./Boosters.vue?vue&type=script&lang=js"
export * from "./Boosters.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Downloads\\21TCG\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__